import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const FindYourCommunity = ({ onBrowseOrganizations }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 min-h-[400px]">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="rounded-full bg-blue-100 p-4">
            <UserGroupIcon className="h-12 w-12 text-blue-600" />
          </div>
        </div>
        
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
          Find Your Community
        </h2>
        
        <p className="text-gray-600 mb-8 text-sm sm:text-base leading-relaxed">
          Connect with organizations and communities that share your mission. 
          Join a local church, ministry, or group to start sharing stories and growing together.
        </p>
        
        <button
          onClick={onBrowseOrganizations}
          className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium text-sm sm:text-base shadow-sm"
        >
          Browse Organizations
        </button>
        
        <p className="mt-6 text-sm text-gray-500">
          You can skip this for now and explore later
        </p>
      </div>
    </div>
  );
};

export default FindYourCommunity;
